import { useState, useEffect } from 'react'
import { ChevronUp, ChevronDown } from 'lucide-react'

export function ScrollButtons() {
  const [showUp, setShowUp] = useState(false)
  const [showDown, setShowDown] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY
      const scrollHeight = document.documentElement.scrollHeight
      const clientHeight = document.documentElement.clientHeight
      
      // Show up button after 300px
      setShowUp(scrollY > 300)
      
      // Hide down button if at the bottom
      setShowDown(scrollY + clientHeight < scrollHeight - 100)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll() // Initial check
    
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' })
  }

  return (
    <div className="fixed bottom-8 right-8 flex flex-col gap-3 z-50">
      {showUp && (
        <button
          onClick={scrollToTop}
          className="w-12 h-12 bg-gray-900 border border-gray-800 rounded-2xl flex items-center justify-center text-green-500 shadow-2xl hover:bg-green-600 hover:text-white hover:border-green-500 transition-all active:scale-90 animate-fade-in"
          title="Scroll to Top"
        >
          <ChevronUp size={24} />
        </button>
      )}
      
      {showDown && (
        <button
          onClick={scrollToBottom}
          className="w-12 h-12 bg-gray-900 border border-gray-800 rounded-2xl flex items-center justify-center text-blue-500 shadow-2xl hover:bg-blue-600 hover:text-white hover:border-blue-500 transition-all active:scale-90 animate-fade-in"
          title="Scroll to Bottom"
        >
          <ChevronDown size={24} />
        </button>
      )}
    </div>
  )
}
